.container {
  width: 270px;
}

.creds-span {
  font-size: 12px;
  font-weight: 400;
}

.preview-header {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 5px;
}

.preview-content {
  font-size: 12px;
  color: var(--default--text-color--5);
  line-height: 18px;
}
